import React from "react";
import { Link } from "react-router-dom";
import "./Services.css";
import Permanent from "./IMG/Permanent.svg";
import Temporary from "./IMG/Temporary.svg";
import Payroll from "./IMG/Payroll.svg";
import International from "./IMG/International.svg";
import Dedicated from "./IMG/Dedicated.svg";
import Executive from "./IMG/executive.svg";
import Bulk from "./IMG/Bulk.svg";

const services = [
  { title: "Permanent Staffing", path: "/PermanentStaffing", image: Permanent, text: "Clarify the role, essential skills, selection criteria and offer terms before a permanent hire." },
  { title: "Temporary Staffing", path: "/TemporaryStaffing", image: Temporary, text: "Agree on assignment dates, working conditions, supervision and the handover plan." },
  { title: "Payroll Management", path: "/PayRoll", image: Payroll, text: "Prepare payroll inputs, approvals, reconciliations and clear employee query handling." },
  { title: "International Recruitment", path: "/International", image: International, text: "Coordinate cross-border role requirements and candidate communication while verifying destination rules separately." },
  { title: "Dedicated IT Resources", path: "/DedicatedIt", image: Dedicated, text: "Define technical outcomes, required skills, working arrangements and access responsibilities." },
  { title: "Executive Search", path: "/Executive", image: Executive, text: "Set a clear leadership mandate and evaluate candidates against agreed, job-related evidence." },
  { title: "Bulk Hiring", path: "/BulkHiring", image: Bulk, text: "Plan hiring batches, consistent assessment, interview schedules and joining logistics." },
  { title: "Visa Assistance", path: "/VisaAssistance", image: International, text: "Prepare questions and document checklists using current official guidance; authorities decide applications." }
];

function Services() {
  return (
    <section className="home-services-section" aria-labelledby="home-services-heading">
      <div className="home-services-heading">
        <p>Our Services</p>
        <h2 id="home-services-heading">Recruitment support with clear next steps</h2>
        <p>Explore the service that fits your requirement, then review the information to prepare before contacting our team.</p>
      </div>
      <div className="home-service-grid">
        {services.map((service) => (
          <article className="home-service-card" key={service.path}>
            <img src={service.image} alt="" loading="lazy" />
            <div>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
              <Link to={service.path}>Read service guide <span aria-hidden="true">→</span></Link>
            </div>
          </article>
        ))}
      </div>
      <p className="home-services-note">Recruitment outcomes depend on employer decisions and candidate suitability. Visa and work-authorisation decisions are made by the relevant authorities.</p>
    </section>
  );
}
export default Services;
